import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-pet-rehome-modal-header',
  templateUrl: './pet-rehome-modal-header.component.html',
})
export class PetRehomeModalHeaderComponent {
  @Input('redirectTo') redirectTo: string;

  constructor(
    private _activeModal: NgbActiveModal,
    private _router: Router
  ) {}

  public onCloseModal() {
    this._activeModal.close();

    if (this.redirectTo) {
      this._router.navigate(['/dashboard']);
    }
  }

}
